module.exports = __webpack_public_path__ + "img/channel.74fe898c.webp";